import Cookies from "js-cookie";

export default function getCSRFToken(): string {
  return Cookies.get("CSRF-TOKEN") || "";
}
